import { AutogenModelPnnLoadSched, AutogenRowPnnLoadSched } from "./autogen/AutogenModelPnnLoadSched";

export class ModelPnnLoadSched extends AutogenModelPnnLoadSched<RowPnnLoadSched> {
	constructor() {
		super(RowPnnLoadSched);
	}
}

export class RowPnnLoadSched extends AutogenRowPnnLoadSched {
}